import { render } from "./BadgeCheck.vue?vue&type=template&id=0e468f70&scoped=true"
import script from "./BadgeCheck.vue?vue&type=script&lang=js"
export * from "./BadgeCheck.vue?vue&type=script&lang=js"

import "./BadgeCheck.vue?vue&type=style&index=0&id=0e468f70&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e468f70"]])

export default __exports__